export default "__VITE_ASSET__BitHg7$n__"